import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { CallCenterRoutingModule } from "./call-center-routing.module";
import { ClientFormComponent } from "./pages/clients/components/client-form/client-form.component";
import { SharedModule } from "src/app/shared/shared.module";
import { ClientsService } from "./pages/clients/services/clients.service";
import { ClientListComponent } from "./pages/clients/components/clients-list/clients-list.component";
import { ClientsComponent } from "./pages/clients/clients.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  NgbAlertModule,
  NgbDropdownModule,
  NgbNavModule,
  NgbPaginationModule,
  NgbTooltipModule,
  NgbAccordionModule,
  NgbModalModule
} from "@ng-bootstrap/ng-bootstrap";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";
import { ContactsModule } from "./pages/contacts/contacts.module";
import { StatusConfigComponent } from "./pages/status-config/status-config.component";
import { CustomMessageListComponent } from "./pages/status-config/components/custom-message-list/custom-message-list.component";
import { StatusConfigListComponent } from "./pages/status-config/components/status-message-list/status-message-list.component";
import { SettingProjectsComponent } from "./pages/projects/pages/setting/setting-projects/setting-projects.component";
import { ProjectFinishedComponent } from "./pages/projects/pages/finished/project-finished/project-finished.component";
import { CardSettingsComponent } from "./pages/projects/pages/setting/components/card-settings/card-settings.component";
import { DocumentTemplatesComponent } from "./pages/projects/pages/setting/setting-projects/pages/document-templates/document-templates.component";
import { ModalExcluirComponent } from "./pages/projects/pages/setting/components/modal-excluir/modal-excluir.component";
import { BudgetParameterComponent } from "./pages/projects/pages/setting/setting-projects/pages/budget-parameter/budget-parameter.component";
import { UiSwitchModule } from 'ngx-ui-switch';
import { BudgetParameterRegisterComponent } from "./pages/projects/pages/setting/setting-projects/pages/budget-parameter-register/budget-parameter-register.component";
import { BudgetParameterEditComponent } from "./pages/projects/pages/setting/setting-projects/pages/budget-parameter-edit/budget-parameter-edit.component";
import { BudgetItemListComponent } from "./pages/projects/pages/budget-item/budget-item-list/budget-item-list.component";
import { ModaEditarComponent } from "./pages/projects/pages/budget-item/budget-item-list/components/moda-editar/moda-editar.component";
import { NgxCurrencyDirective } from "ngx-currency";
import { ModalConfirmDelecaoComponent } from "src/app/shared/modal/modal-confirm-delecao/modal-confirm-delecao.component";
import { BudgetItemCreateModalComponent } from "./pages/projects/pages/budget-item/budget-item-create-modal/budget-item-create-modal.component";
import { ClientProjectComponent } from "./pages/clients/components/client-project/client-project.component";
import { ClientMessagesComponent } from "./pages/clients/components/client-messages/client-messages.component";
import { DocumentsModalComponent } from "./pages/clients/components/documents-modal/documents-modal.component";
import { AddDocumentsModalComponent } from "./pages/clients/components/add-documents-modal/add-documents-modal.component";
import { BudgetViewComponent } from "./pages/projects/pages/documents/budget-view/budget-view.component";
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { NgStepperModule } from 'angular-ng-stepper';
import { FormParametroOrcamentoComponent } from "./pages/projects/pages/documents/components/form-parametro-orcamento/form-parametro-orcamento.component";
import { TotaisComponent } from "./pages/projects/pages/documents/components/totais/totais.component";
import { TableItemOrcamentoComponent } from "./pages/projects/pages/documents/components/table-item-orcamento/table-item-orcamento.component";
import { ModalEditarItemGrupoComponent } from "./pages/projects/pages/documents/components/modal-editar/modal-editar-item-grupo.component";
import { CustomMessageFormComponent } from "./pages/status-config/components/custom-message-form/custom-message-form.component";
import { StatusConfigFormComponent } from "./pages/status-config/components/status-message-form/status-config-form.component";
import { StatusDocumentoComponent } from "./pages/clients/components/status/status-documento/status-documento.component";
import { AtualizarStatusProjetoComponent } from "./pages/clients/components/status-projeto/atualizar-status-projeto/atualizar-status-projeto.component";
import { AddAttendantModalComponent } from "./pages/contacts/pages/get-lists/components/add-attendant-modal/add-attendant-modal.component";
import { EditarPropostaComercialComponent } from "./pages/projects/pages/documents/proposta-comercial/editar-proposta-comercial/editar-proposta-comercial.component";
import { EditarContratoComponent } from "./pages/projects/pages/documents/contrato/editar-contrato/editar-contrato.component";
import { FormEditarContratoComponent } from "./pages/projects/pages/documents/contrato/editar-contrato/components/form-editar-contrato/form-editar-contrato.component";
import { ProcessandoAssinaturaComponent } from "./pages/projects/pages/documents/contrato/editar-contrato/components/processando-assinatura/processando-assinatura.component";
import { UploadDocumentoComponent } from "./pages/projects/pages/documents/contrato/editar-contrato/components/upload-documento/upload-documento.component";
import { SignatarioComponent } from "./pages/projects/pages/documents/contrato/editar-contrato/components/signatario/signatario.component";
import { DocumentoEnviadoComponent } from "./pages/projects/pages/documents/contrato/editar-contrato/components/documento-enviado/documento-enviado.component";
import { CardEtapaConcluidaComponent } from "./pages/projects/pages/documents/contrato/editar-contrato/components/card-etapa-concluida/card-etapa-concluida.component";
import { CardTituloEtapaComponent } from "./pages/projects/pages/documents/contrato/editar-contrato/components/card-titulo-etapa/card-titulo-etapa.component";
import { DocumentoAssinaturaComponent } from "./pages/projects/pages/documents/contrato/documento-assinatura/documento-assinatura.component";
import { FlatpickrModule } from 'angularx-flatpickr';
import { ModalAtualizarFeiraClienteComponent } from "./pages/clients/components/modal-atualizar-feira-cliente/modal-atualizar-feira-cliente.component";
import { ModalAdicionarMensagemComponent } from "./pages/clients/components/modal-adicionar-mensagem/modal-adicionar-mensagem.component";
import { WhatsappAttendanceComponent } from "./pages/whatsapp/pages/whatsapp-attendance/whatsapp-attendance.component";
import { WhatsappConfigComponent } from "./pages/whatsapp/pages/whatsapp-config/whatsapp-config.component";
import { ChatDashboardComponent } from "./pages/whatsapp/pages/chat-dashboard/chat-dashboard.component";
import { TransferirConversaModalComponent } from "./pages/whatsapp/pages/whatsapp-attendance/transferir-conversa-modal/transferir-conversa-modal.component";
import { ProjetoListComponent } from "./pages/projects/pages/projeto-list/projeto-list.component";
import { ProjetoFormModalComponent } from "./pages/projects/pages/projeto-form-modal/projeto-form-modal.component";
import { OrcamentoListComponent } from "./pages/projects/pages/orcamento-list/orcamento-list.component";
import { DashboardCallCenterComponent } from "./pages/dashboard/dashboard-call-center.component";

@NgModule({
  declarations: [
    ClientsComponent,
    ClientListComponent, 
    ClientFormComponent, 
    StatusConfigComponent,
    CustomMessageListComponent,
    StatusConfigListComponent,
    SettingProjectsComponent,
    ProjectFinishedComponent,
    CardSettingsComponent,
    DocumentTemplatesComponent,
    ModalExcluirComponent,
    BudgetParameterComponent,
    BudgetParameterRegisterComponent,
    BudgetParameterEditComponent,
    BudgetItemListComponent,
    ModaEditarComponent,
    ModalConfirmDelecaoComponent,
    BudgetItemCreateModalComponent,
    ClientProjectComponent,
    ClientMessagesComponent,
    DocumentsModalComponent,
    AddDocumentsModalComponent,
    BudgetViewComponent,
    FormParametroOrcamentoComponent,
    TotaisComponent,
    TableItemOrcamentoComponent,
    ModalEditarItemGrupoComponent,
    CustomMessageFormComponent,
    StatusConfigFormComponent,
    StatusDocumentoComponent,
    AtualizarStatusProjetoComponent,
    AddAttendantModalComponent,
    EditarPropostaComercialComponent,
    EditarContratoComponent,
    FormEditarContratoComponent,
    ProcessandoAssinaturaComponent,
    UploadDocumentoComponent,
    SignatarioComponent,
    DocumentoEnviadoComponent,
    CardEtapaConcluidaComponent,
    CardTituloEtapaComponent,
    DocumentoAssinaturaComponent,
    ModalAtualizarFeiraClienteComponent,
    ModalAdicionarMensagemComponent,
    WhatsappAttendanceComponent,
    WhatsappConfigComponent,
    ChatDashboardComponent,
    TransferirConversaModalComponent,
    ProjetoListComponent,
    ProjetoFormModalComponent,
    OrcamentoListComponent,
    DashboardCallCenterComponent
  ],
  imports: [
    SharedModule,
    FormsModule,
    CommonModule,
    CallCenterRoutingModule,
    ReactiveFormsModule,
    NgbPaginationModule,
    NgbTooltipModule,
    NgbDropdownModule,
    NgbModalModule,
    NgxMaskPipe,
    NgxMaskDirective,
    ContactsModule,
    NgbNavModule,
    NgbAlertModule,
    UiSwitchModule,
    NgxCurrencyDirective,
    NgbAccordionModule,
    CdkStepperModule,
    CKEditorModule,
    NgStepperModule,
    FlatpickrModule.forRoot()
  ],
  exports: [
    DashboardCallCenterComponent
  ],
  providers: [ClientsService, provideNgxMask()],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CallCenterModule {}
